module.exports = __webpack_public_path__ + "static/about-insta-8-dfc3784fe0fed1e7d494799e6f660a30.jpg";